import type { ChatMessage } from './lobbyStore.types';

/**
 * Prune a room transcript to `max` messages (dropping oldest) while never
 * evicting the pinned revealing message. A live stream mid-flight is pinned
 * via `revealingMessageIds`; chunks land on its bubble by id, so evicting it
 * silently destroys the rest of the stream (the pin keeps pointing at a
 * ghost id and every later chunk no-ops). When the pinned message falls in
 * the drop window it is rescued to the front and one extra old message is
 * dropped to stay at the cap.
 *
 * Every transcript prune site must go through this helper: a single
 * unguarded `slice(-max)` anywhere (addMessage, reveal-queue flush, skip
 * dump) re-opens the eviction hole the others closed.
 */
export function pruneMessages(
  messages: ChatMessage[],
  max: number,
  pinnedId: string | null | undefined
): ChatMessage[] {
  const cut = messages.length - max;
  if (cut <= 0) return messages;
  const pinnedVictim = pinnedId ? messages.slice(0, cut).find((m) => m.id === pinnedId) : undefined;
  return pinnedVictim ? [pinnedVictim, ...messages.slice(cut + 1)] : messages.slice(cut);
}
